import isEqual from 'lodash/isEqual';
import isPlainObject from 'lodash/isPlainObject';
import keys from 'lodash/keys';
import React from 'react';

/**
 * Passes props from a parent component to this.props.children components
 *
 * @param  {Array} children - the array of children components that need to inherit props from its parent component. (i.e this.props.children)
 * @param  {object} propsObj - an object that contains the key/value pair of props you want the parent component to send to the children components
 * @returns {Array} children components that now have the new props from the parent component.
 */
export function passPropsToChildren(
  children: React.ReactElement[],
  propsObj: $TSFixMe,
): React.ReactElement[] {
  return React.Children.map(children, (child: React.ReactElement) => {
    let childProps = {};
    if (React.isValidElement(child)) {
      childProps = propsObj;
    }
    if (child.props) {
      return React.cloneElement(child, childProps);
    }
    return child;
  });
}

/**
 * Utility function to validate an array of props against a list of allowed of values
 *
 * @param {List} allowedValues
 * @returns {Function} validator function
 */
export function getArrayOfAllowedValuesValidator(allowedValues: $TSFixMe) {
  return (
    propValue: $TSFixMe,
    key: number,
    componentName: $TSFixMe,
    _location: $TSFixMe,
    propFullName: $TSFixMe,
  ): void => {
    if (!allowedValues || allowedValues.length === 0) {
      return;
    }

    if (allowedValues.indexOf(propValue[key]) === -1) {
      throw new Error(
        `Invalid prop ${propFullName} supplied to ${componentName} (${propValue[key]}). Validation failed.`,
      );
    }
  };
}

export function arePropsDifferent(nextProps: $TSFixMe, currentProps: $TSFixMe): boolean {
  const nextPropsKeys = keys(nextProps);
  const currentPropsKeys = keys(currentProps);

  if (
    nextPropsKeys.length !== currentPropsKeys.length ||
    !isEqual(nextPropsKeys, currentPropsKeys)
  ) {
    return true;
  }

  // same keys. same values?
  for (let x = 0; x < nextPropsKeys.length; x++) {
    const key = nextPropsKeys[x];
    const current = currentProps[key];
    const next = nextProps[key];

    if (current === next) {
      continue;
    }

    if (current && current.equals) {
      if (!current.equals(next)) {
        return true;
        // eslint-disable-next-line no-else-return
      } else {
        continue;
      }
    }

    if (isPlainObject(current)) {
      if (!isEqual(current, next)) {
        return true;
        // eslint-disable-next-line no-else-return
      } else {
        continue;
      }
    }

    if (current !== next) {
      return true;
    }
  }
  return false;
}
